import { forwardRef, useState, useRef, useImperativeHandle } from "react";
import { DropDown } from "@etframework/ui.components";
import { Trans, useTranslation } from "react-i18next";
import { useTaxYears } from "../../data/queries/taxReturnQueries";
import Enums from "../../types/enums";

export const TaxYearDropDown = forwardRef(
  ({ onChange, initialValue, id, initialTaskType }, ref) => {
    const { t, i18n } = useTranslation(["CreateTaskModal"]);
    const componentRef = useRef();
    const [hasTaskTaxReturnInfo, setHasTaskTaxReturnInfo] = useState(
      initialTaskType?.Type === Enums.TaskType.TaxReturn
    );

    const { data: taxYears } = useTaxYears();

    const fields = {
      text: "Year",
      value: "Id"
    };

    useImperativeHandle(
      ref,
      () => ({
        getValue: () => componentRef.current?.getValue(),
        setValue: (val) => componentRef.current?.setValue(val),
        getItemData: () => componentRef.current?.getItemData(),
        setError: (msg) => componentRef.current?.setError(msg),
        setHasTaskTaxReturnInfo
      }),
      [componentRef]
    );

    if (!hasTaskTaxReturnInfo) return;

    return (
      <div className="col-3">
        <DropDown
          ref={componentRef}
          value={initialValue}
          name="TaskTaxReturnInfo.TaxYear"
          dataSource={taxYears}
          fields={fields}
          htmlFor={id}
          id={id}
          label={
            <Trans components={{ b: <span className="et-red" /> }}>
              {t("TaxYearLabel")}
            </Trans>
          }
          errorMessage={t("ErrorMsg")}
          locale={i18n?.language}
          change={onChange}
          sortOrder="Descending"
        />
      </div>
    );
  }
);
